






























import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class Aside extends Vue {
  @Prop() index?: number;
  @Prop() pages?: { key: string; name: string }[];
  @Prop() value: any;
  @Prop() open?: boolean;
  type(i: number, page: { key: string; name: string }): string {
    if (
      this.pages != undefined &&
      this.index != undefined &&
      this.value != undefined
    ) {
      if (this.index == i) {
        return "current";
      }
      if (this.value[page.key].isValid) {
        return "visited";
      } else if (i > this.index) {
        return "unvisited";
      }
    }
    return "current";
  }
  @Emit("change")
  onChange(i: number): number {
    return i;
  }
}
